export const urlUser = "https://users-block-master.herokuapp.com/users/"
export const urlFavorites = "https://users-block-master.herokuapp.com/favorites/"